<template>
  <div v-if="session">
    <v-tabs
      v-model="tab"
      style="position:fixed; bottom: 0;"
      centered
      icons-and-text
    >
      <v-tabs-slider color="red" />

      <div
        v-for="tabItem in tabs"
        :key="`tab_switcher_instructor_${tabItem.tabKey}`"
        style="border-top: 1px solid red;"
      >
        <v-tab :href="`#${tabItem.tabKey}`" :class="`${tab === tabItem.tabKey ? 'red--text' : 'grey--text'}`">
          {{ tabItem.label }}
          <v-icon v-if="tabItem.icon" :class="[{'third--text': tab === tabItem.tabKey},'grey--text']">{{ tabItem.icon }}</v-icon>
        </v-tab>
      </div>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="tabItem in tabs"
        :key="`tab_content_intrustor_mobile_${tabItem.tabKey}`"
        :value="`${tabItem.tabKey}`"
      >
        <component v-if="!loading" :is="tabItem.component" />
        <div v-else class="d-flex align-center justify-center full-height">
          <Loader />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
  <div v-else class="full-height d-flex align-center justify-center grey--text">
    <ErrorBanner message="Reprise non trouvé" class="d-flex align-center justify-center full-height" :show-return-button="false" />
  </div>
</template>

<script>
import { ref, computed, provide, inject, onMounted, watch, onBeforeMount } from '@vue/composition-api';

import { format, fromUnixTime } from 'date-fns';
import { fr } from 'date-fns/esm/locale';

import store from '@/store';

import TabHorse from '@/components/instructor/tabs/TabHorse.vue';
import TabBilan from '@/components/instructor/tabs/TabBilan.vue';
import TabObservation from '@/components/instructor/tabs/TabObservation.vue';
import ErrorBanner from '@/components/common/ErrorBanner.vue';
import { updateSessionAmplify } from '@/helpers/amplify';
import Loader from '@/components/common/Loader.vue';

export default {
  components: {
    TabHorse,
    TabObservation,
    TabBilan,
    ErrorBanner,
    Loader
  },
  setup (_, context) {
    const tab = ref(null);
    const loading = ref(false);

    const tabs = ref([
      { tabKey: 'horse', icon: 'mdi-horse', label: 'Chevaux', component: 'TabHorse' },
      { tabKey: 'bilan', icon: 'mdi-account-multiple', label: 'Bilan', component: 'TabBilan' },
      { tabKey: 'observation', icon: 'mdi-file-document', label: 'Commentaire', component: 'TabObservation' }
    ]);

    const date = inject('currentMonth');

    const route = context.root.$route;

    const { session_id } = route.params;

    const session = computed(() => {
      const foundedSession = store.state.instructorSessions.find(s => s.id === session_id);
      if (!foundedSession) {
        return null;
      }

      foundedSession.participants = foundedSession.participants.map(p => ({
        ...p,
        presenceMarked: !!p.presence_status
      }));

      return foundedSession;
    });

    onMounted(async () => {
      // await store.dispatch('instructorSessions');
      if (session.value) {
        date.value = format(new Date(fromUnixTime(session.value.start_time)), 'LLLL', { locale: fr });
      }
    });

    watch(session, () => {
      if (session.value) {
        date.value = format(new Date(fromUnixTime(session.value.start_time)), 'LLLL', { locale: fr });
      }
    });

    const updateSession = async () => {
      const sessionToUpdate = { ...session.value };

      sessionToUpdate.participants = (sessionToUpdate.participants || []).map(p => {
        const { presenceMarked, ...participant } = p;
        return participant;
      });
      await updateSessionAmplify(sessionToUpdate);
    };

    onBeforeMount(async () => {
      loading.value = true;
      if (!store.state.isLazyLoaded.horses) {
        await store.dispatch('getHorses');
      }
      loading.value = false;
    });

    provide('updateSession', updateSession);
    provide('selectedSession', session);

    return { tab, tabs, session, loading };
  }
};

</script>
